/**
 * Created by etienne on 08/01/18.
 */
import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'

class VersionService {

    getApiVersion() {
        return WebService.call('/api/version', HttpMethods.GET);
    }

}

export default new VersionService();



// WEBPACK FOOTER //
// ./src/services/VersionService.js